/*
layers to be presented in the project detail page sidebar
for now i only added norwegian sources, as didn not research enough in other countries.
*/
const projectPhaseColors = {
	
	states : {
		"In screening": {
			color:"#c4c7cd",
			textColor: "#040C14",
			icon:"ri-glasses-2-line"
		},
		"Landowners contacted":  {
			color: "#166ee1",
			textColor: "#ffffff",
			icon:"ri-phone-line"
		},
		"Landowner dialog":  {
			color: "#ffd66b",
			textColor: "#040C14",
			icon:"ri-message-3-line"
		},
		"Landowner agreement":  {
			color: "#048a0e",
			textColor: "#ffffff",
			icon:"ri-shake-hands-line"
		},
		"Permitting":  {
			color: "#dd04a8",
			textColor: "#ffffff",
			icon:"ri-shield-check-line"
		}
	},
	"get" : function(status) {
		
		return (this.states[status] ? this.states[status] : {"color" : "#c4c7cd", "textColor":"#ffffff"});
	},
	"getOpt" : function(status) {
		if(!status)
			return {value:'', label:''};
		return {
			"label": status, 
			"value":status, 
			"color": this.states[status].color,
			"textColor": this.states[status].textColor
		};
	},
	"getIcon" : function(status) {
		
		return (this.states[status] ? this.states[status].icon : "");
	},
	"asOpts" : function(){
		return Object.getOwnPropertyNames(this.states).map(status => {
			return {
				"label": status, 
				"value":status, 
				"color": this.get(status).color,
				"textColor": this.get(status).textColor
			};
		})
	},
	"colors" : function(status) {
		const c = this.get(status);
		return {backgroundColor:c.color, color:c.textColor};
	}
}

const projectStatusColors = {
	
	states : {
		"In development": {
			color: "#63a04d",
			textColor : "#ffffff"
		},
		"On hold": {
			color: "#2944d1",
			textColor : "#ffffff"
		},
		"Terminated": {
			color: "#ff0404",
			textColor : "#ffffff"
		},
		"Merged": {
			color: "#FFDC1C",
			textColor : "#040C14"
		}
	},
	"get" : function(status) {
		
		return (this.states[status] ? this.states[status] : {"color" : "#c4c7cd", "textColor":"#ffffff"});
	},
	"getOpt" : function(status) {
		
		return {
			"label": status, 
			"value":status, 
			"color": this.states[status].color,
			"textColor": this.states[status].textColor
		};
	},
	"asOpts" : function(){
		return Object.getOwnPropertyNames(this.states).map(status => {
			return {
				"label": status, 
				"value":status, 
				"color": this.states[status].color, 
				"textColor": this.states[status].textColor
			};
		})
	},
	"colors" : function(status) {
		const c = this.get(status);
		return {backgroundColor:c.color, color:c.textColor};
	}
}


export { projectPhaseColors, projectStatusColors };


